<template>
  <v-container fill-height justify-content-start :class="{'pa-2': $vuetify.breakpoint.xsOnly}" class="app-section-width">
    <v-layout column>
      <v-toolbar color="white" flat>
        <v-toolbar-title class="grey--text text--darken-4 pa-0">{{ $t('headers.password') }}</v-toolbar-title>
      </v-toolbar>
      <v-flex class="app-scroll-section">
        <ValidationObserver ref="passwordForm" v-slot="{ }">
          <v-form class="mt-4">
            <ValidationProvider :name="$t('fields.new_password')" rules="required|min:6" v-slot="{ errors }" vid="password">
              <v-text-field
                :label="$t('fields.new_password')"
                type="password"
                v-model="newPassword"
                :error-messages="errors"
                filled
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider :name="$t('fields.repeat_new_password')" rules="required|confirmed:password" v-slot="{ errors }">
              <v-text-field
                :label="$t('fields.repeat_new_password')"
                type="password"
                v-model="repeatNewPassword"
                :error-messages="errors"
                filled
              ></v-text-field>
            </ValidationProvider>
            <v-btn
              @click="savePassword()"
              outlined
              block
              class="mb-4"
            >
              {{ $t('actions.set_password') }}
            </v-btn>
            <v-btn
              @click="ignore()"
              text
              block
              small
            >
              {{ $t('actions.cancel') }}
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import routeNames from '../router/routes'
import router from '@/router'
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data () {
    return {
      newPassword: null,
      repeatNewPassword: null,
    }
  },
  methods: {
    ignore: function () {
      router.push({ name: routeNames.main.name })
    },
    savePassword () {
      let self = this
      this.$refs.passwordForm.validate().then(success => {
        if (success) {
          this.$store.dispatch('me/putPassword', { newPassword: this.newPassword }).then(response => {
            self.resetPasswordForm()
            self.changePassword = false
            self.$store.commit('state/setMessage', { text: self.$t('success.change_password'), color: 'success' })
            router.push({ name: routeNames.main.name })
          }, () => {
            self.$store.commit('state/setMessage', { text: self.$t('error.change_password'), color: 'error' })
          })
        }
      })
    },
    resetPasswordForm () {
      this.newPassword = null
      this.repeatNewPassword = null
      this.$refs.passwordForm.reset()
    },
  },
  created () {
    this.$store.dispatch('me/getSettings').then((settings) => {
      if (settings.hasPassword === undefined || (settings.hasPassword !== undefined && settings.hasPassword)) {
        this.ignore()
      }
    })
  },
}
</script>

<style lang="scss">
</style>
